import { FC } from "react";

import Anchor from "web/Components/Common/Anchor";

import { trackCategoryExpand } from "web/utils/system/GTM/navigationGtmEvents";

import ArrowRightIcon from "web/assets/icons/arrow-right.svg";

import classes from "./navItem.scss";

interface INavItemProps {
  to: string;
  title: string;
  onClick?: () => void;
}

const NavItem: FC<INavItemProps> = ({ to, title, onClick }) => (
  <Anchor
    className={classes.navItem}
    to={to}
    onClick={() => {
      trackCategoryExpand(title);
      onClick?.();
    }}
  >
    <span>{title}</span>
    <ArrowRightIcon width={10} />
  </Anchor>
);

export default NavItem;
